import React from "react";
import { ImageContentPage as PageType } from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  onNext: () => void;
}

const ImageContentPage: React.FC<Props> = ({ page, onNext }) => {
  return (
    <div className="page page--image-content">
      <div className="page__container">
        <div className="image-content">
          <img
            src={page.image}
            alt={page.title}
            className="image-content__image"
          />
          <div className="image-content__text">
            <h2 className="image-content__title">{page.title}</h2>
            {page.subtitle && (
              <p className="image-content__subtitle">{page.subtitle}</p>
            )}
          </div>
        </div>

        <button className="page__button" onClick={onNext}>
          {page.buttonText}
        </button>
      </div>
    </div>
  );
};

export default ImageContentPage;
